import React, { forwardRef, memo } from 'react';
import { AppInput, AppInputProps } from '../app-input';
import { useAppSelector } from 'store';
import { selectLanguageIsRtl } from 'store/languages';
import { objectSlotProps } from 'utils/slot-props';

const Input = (props: AppInputProps, ref: ForwardedRef<HTMLInputElement>) => {
  const isRTL = useAppSelector(selectLanguageIsRtl);
  const htmlInput = objectSlotProps(props.slotProps?.htmlInput);
  return (
    <AppInput
      ref={ref}
      {...props}
      slotProps={{
        ...props.slotProps,
        htmlInput: {
          ...htmlInput,
          dir: 'ltr',
          style: { ...htmlInput?.style, textAlign: isRTL ? 'right' : 'left' },
        },
      }}
    />
  );
};

export const AppInputLtr = memo(forwardRef(Input));
